export const analyzeLocation = (t, locationObj) => {
    console.log(locationObj)
  const country = locationObj.address_components.find((item) =>
    item.types.includes('country')
  );
  if (country) {
    const region = locationObj.address_components.find((item) =>
      item.types.includes('administrative_area_level_1')
    );
    if (region) {
      const city = locationObj.address_components.find((item) =>
        item.types.includes('locality')
      );
      if (city) {
        const street = locationObj.address_components.find((item) =>
          item.types.includes('route')
        );
        if (street) {
          return {
            fullLocation: true,
            mostDetailedLevel: 'street',
            lat: locationObj.geometry.location.lat(),
            lng: locationObj.geometry.location.lng(),
            formatted_address: locationObj.formatted_address,
            short_address: `${country.long_name} ${city.long_name}`,
            labelColor: 'success.main',
            labelMsg: t('views.redesignScreens.accessActive'),
          };
        } else {
          return {
            fullLocation: false,
            mostDetailedLevel: 'city',
            lat: locationObj.geometry.location.lat(),
            lng: locationObj.geometry.location.lng(),
            formatted_address: locationObj.formatted_address,
            short_address: `${country.long_name} ${city.long_name}`,
            labelColor: 'warning.main',
            labelMsg: t('views.redesignScreens.accessLimited'),
          };
        }
      } else {
        return {
          fullLocation: false,
          mostDetailedLevel: 'region',
          lat: locationObj.geometry.location.lat(),
          lng: locationObj.geometry.location.lng(),
          formatted_address: locationObj.formatted_address,
          short_address: country.long_name,
          labelColor: 'warning.main',
          labelMsg: t('views.redesignScreens.accessLimited'),
        };
      }
    } else {
      return {
        fullLocation: false,
        mostDetailedLevel: 'country',
        lat: locationObj.geometry.location.lat(),
        lng: locationObj.geometry.location.lng(),
        formatted_address: locationObj.formatted_address,
        short_address: country.long_name,
        labelColor: 'warning.main',
        labelMsg: t('views.redesignScreens.accessLimited'),
      };
    }
  } else {
    return {
      fullLocation: false,
      mostDetailedLevel: null,
      lat: locationObj.geometry.location.lat(),
      lng: locationObj.geometry.location.lng(),
      formatted_address: locationObj.formatted_address,
      short_address: locationObj.formatted_address,
      labelColor: 'warning.main',
      labelMsg: t('views.redesignScreens.accessLimited'),
    };
  }
};
